
































import Vue from 'vue'
import { ProductionCardServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import mixin from './cardmixin.vue'
const pcsp = new ProductionCardServiceProxy()

export default Vue.extend({
  name: 'unfinished-plan-table',
  mixins: [mixin],
  data() {
    return {
      data: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_control_code'),
          key: 'code',
          dataIndex: 'code',
          width: 100
        },
        {
          title: this.$t('page_control_category'),
          key: 'category',
          dataIndex: 'category',
          scopedSlots: { customRender: 'category' },
          width: 100
        },
        {
          title: this.$t('page_control_planNum'),
          key: 'planNum',
          dataIndex: 'planNum',
          width: 100
        },
        {
          title: this.$t('page_control_unit'),
          key: 'unit',
          dataIndex: 'unit',
          width: 100
        },
        {
          title: this.$t('page_control_status'),
          key: 'status',
          dataIndex: 'planStatus',
          scopedSlots: { customRender: 'status' },
          width: 100
        },
        {
          title: this.$t('page_control_planSchedule'),
          key: 'planSchedule',
          dataIndex: 'planSchedule',
          scopedSlots: { customRender: 'planSchedule' },
          width: 200
        },
        {
          title: this.$t('page_control_productName'),
          key: 'productName',
          dataIndex: 'productName',
          width: 100
        },
        {
          title: this.$t('page_control_productCode'),
          key: 'productCode',
          dataIndex: 'productCode',
          width: 100
        },
        {
          title: this.$t('page_control_standardModel'),
          key: 'standardModel',
          dataIndex: 'standardModel',
          width: 100
        }
      ]
    },
    badgeStatus() {
      return [
        {
          name: this.$t('page_control_default'),
          status: 1,
          type: 'default'
        },
        {
          name: this.$t('page_control_processing'),
          status: 2,
          type: 'processing'
        },
        {
          name: this.$t('page_control_success'),
          status: 3,
          type: 'success'
        },
        {
          name: this.$t('page_control_error'),
          status: 4,
          type: 'error'
        }
      ]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      pcsp.getUnfinishedPlan().then((res) => {
        this.data = res
      })
    },
    getStatus(value) {
      const data = this.badgeStatus.find((res) => res.status == value)
      return data.type
    },
    getText(value) {
      const data = this.badgeStatus.find((res) => res.status == value)
      return data.name
    }
  }
})
